import React from "react";
import { Ear, Stethoscope, Eye, HeartPulse } from "lucide-react";
import { MssantePersonaPage } from "../MssantePersonaPage";

const FAQ = [
  {
    q: "Un audioprothésiste peut-il avoir une boîte MSSanté ?",
    a: "Oui. Les audioprothésistes diplômés disposant d'un numéro ADELI sont éligibles au référentiel MSSanté de l'Agence du Numérique en Santé. La messagerie sécurisée MSSanté est même fortement recommandée pour échanger avec les ORL prescripteurs, les médecins traitants et coordonner les bilans d'appareillage.",
  },
  {
    q: "Pourquoi une boîte organisationnelle pour mon centre d'audioprothèse ?",
    a: "Une boîte organisationnelle MSSanté (rattachée au SIRET de votre centre, partagée par toute votre équipe) garantit la continuité des échanges avec les ORL même en cas d'absence de l'un de vos audioprothésistes. Vos prescripteurs disposent d'une adresse stable, indépendante des mouvements de personnel.",
  },
  {
    q: "Comment l'écosystème OhMyOuie + MSSanté MetaConnect aide-t-il les audioprothésistes ?",
    a: "OhMyOuie est notre plateforme dédiée au parcours auditif. Combinée à la messagerie MSSanté, elle permet d'informer automatiquement l'ORL prescripteur lors d'un démarrage d'appareillage, d'un suivi à 3/6/12 mois ou d'un renouvellement. Le devoir d'information entre audioprothésiste, ORL et médecin traitant est respecté automatiquement, sans ressaisie.",
  },
  {
    q: "La messagerie est-elle adaptée aux centres multi-praticiens ?",
    a: "Oui, c'est précisément la force de la boîte organisationnelle MetaConnect. Vous désignez un responsable, autant de cotitulaires (audioprothésistes salariés, associés) que nécessaire et des délégataires (assistants, secrétaires). Chaque rôle a des droits adaptés. Les échanges restent fluides, même avec plusieurs collaborateurs.",
  },
  {
    q: "Combien coûte une messagerie MSSanté pour audioprothésiste ?",
    a: "Tarification transparente, mensuelle ou annuelle, sans engagement. Pour les groupes ou enseignes nationales d'audioprothèse souhaitant un sous-domaine personnalisé (ex. paris@votre-enseigne.mssante.fr), un devis sur-mesure est établi.",
  },
  {
    q: "Quels logiciels métier audio sont compatibles ?",
    a: "La messagerie MSSanté repose sur le standard S/MIME et l'annuaire santé national : elle est compatible avec tous les logiciels d'audioprothèse conformes au référentiel ANS. L'intégration avec OhMyOuie est native.",
  },
];

export default function MssanteAudioprothesiste() {
  return (
    <MssantePersonaPage
      title="MSSanté audioprothésiste : messagerie · MetaConnect"
      description="Messagerie organisationnelle pour audioprothésistes : multi-utilisateurs, conforme ANS, interopérable, information automatique des ORL prescripteurs."
      canonical="/mssante/audioprothesiste"
      eyebrow="MSSanté · Audioprothésiste · Centre d'audioprothèse"
      eyebrowIcon={Ear}
      h1="Messagerie sécurisée MSSanté pour audioprothésistes"
      intro={<>Une boîte mail MSSanté organisationnelle pensée pour les <strong className="text-white">audioprothésistes</strong> et les centres d'audioprothèse. Coordination automatique avec les ORL et les médecins traitants via notre plateforme <strong className="text-white">OhMyOuie</strong>.</>}
      audienceLabel="Audioprothésiste"
      ctaPrimaryLabel="Créer ma boîte MSSanté audioprothésiste"
      serviceName="Messagerie MSSanté MetaConnect pour audioprothésiste"
      serviceAudience="Audioprothésistes, centres d'audioprothèse, enseignes et groupes audio"
      highlights={[
        "Multi-utilisateurs : tous vos audioprothésistes y accèdent",
        "Information automatique des ORL via OhMyOuie",
        "Conforme ANS · S/MIME · hébergement HDS",
        "Interopérable avec vos logiciels d'audioprothèse",
      ]}
      exchangePartners={[
        { icon: Stethoscope, label: "ORL prescripteurs", desc: "Prescriptions d'appareillage, bilans audiométriques" },
        { icon: HeartPulse, label: "Médecins traitants", desc: "Suivi global du patient, dépistage" },
        { icon: Ear, label: "Orthophonistes", desc: "Coordination de la rééducation auditive" },
      ]}
      ecosystem={{
        title: "OhMyOuie × MSSanté — le parcours auditif coordonné",
        description: <>Combinée à <strong className="text-white">OhMyOuie</strong>, la messagerie MSSanté MetaConnect informe automatiquement l'ORL et le médecin traitant lors d'un démarrage d'appareillage, d'un suivi à 3/6/12 mois ou d'un renouvellement. Devoir d'information respecté, temps gagné pour toute l'équipe.</>,
        focusArea: "parcours auditif",
        focusIcon: Ear,
      }}
      faqs={FAQ}
      siblings={[
        { to: "/mssante/opticien", label: "MSSanté Opticien", icon: Eye, desc: "Spécifique au parcours visuel et OhMyVue.fr" },
        { to: "/mssante/professionnels-de-sante", label: "MSSanté Professionnels de santé", icon: Stethoscope, desc: "Médecins, paramédicaux et structures" },
        { to: "/mssante", label: "Vue d'ensemble MSSanté", icon: Ear, desc: "Tous les avantages de la boîte organisationnelle" },
      ]}
    />
  );
}
